var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 65",
    style: {
      enableBackground: "new 0 0 65 65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4E4E4E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.6,48.7c-8.9,0-16.2-7.3-16.2-16.2c0-8.9,7.3-16.2,16.2-16.2s16.2,7.3,16.2,16.2 C48.7,41.4,41.5,48.7,32.6,48.7z M32.6,19.3c-7.3,0-13.2,5.9-13.2,13.2c0,7.3,5.9,13.2,13.2,13.2s13.2-5.9,13.2-13.2 C45.7,25.2,39.8,19.3,32.6,19.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.6,
    y: 30.4,
    className: "st0",
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 30.4,
    className: "st0",
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 0.7,
    className: "st0",
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 53.6,
    className: "st0",
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4,
    y: 6.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.8709 12.7451)",
    className: "st0",
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.9,
    y: 44.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -20.3767 50.1798)",
    className: "st0",
    width: 3,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.6,
    y: 48.7,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -31.7018 23.8582)",
    className: "st0",
    width: 10.7,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 11.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 5.7334 39.3646)",
    className: "st0",
    width: 10.7,
    height: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleSun);
export default __webpack_public_path__ + "static/media/toggle_sun.604b16628ccb03f2f17be7dc68b02d07.svg";
export { ForwardRef as ReactComponent };